const FULL_FIELDS_MESSAGE_RULE = [ 'id', 'title', 'conditions', 'actions', 'isActive', 'updatedAt', 'createdAt' ]

module.exports = {
  FULL_FIELDS_MESSAGE_RULE
}
